import { QueryKey } from '@/configs/queryKeys';
import { Admin } from '@/types/user';
import EntityApi, { BaseEntity } from './EntityApi';

export enum Currency {
	PLN = 'PLN',
	EUR = 'EUR',
}

export enum CompanyTransportType {
	INTERIOR = 'INTERIOR',
	EXTERIOR = 'EXTERIOR',
}

export interface Company extends BaseEntity {
	name: string;
	admin?: Admin;
	contactPerson: string;
	country: string;
	vatNumber: string;
	city: string;
	postalCode: string;
	street: string;
	houseNumber: string;
	preferredCurrency: Currency;
	preferredTransportType: CompanyTransportType;
}

class CompanyApi extends EntityApi<Company> {
	constructor() {
		super(QueryKey.companies);
	}
}

export default new CompanyApi();
